<template>
  <div>
    <el-form-item label="题干" v-if="config.subject === 'words' || config.subject === 'line'">
      <div class="exr-form-subject">
        <el-input v-model="form.subject"></el-input>
        <PinyinInput v-model="form.subjectPinyin" v-if="config.subjectPinyin" :text="form.subject"></PinyinInput>
      </div>
    </el-form-item>
    <el-form-item label="题干" v-else-if="config.subject === 'text' || config.subject === 'dialog'">
      <div class="exr-form-subject" @change.native.capture="handleDialogText(form, 'subject', 'subjectPinyin')">
        <el-input type="textarea" v-model="form.subject" resize="none" :autosize="{minRows:2}"></el-input>
        <PinyinInput type="textarea" v-if="config.subjectPinyin" v-model="form.subjectPinyin" resize="none" :autosize="{minRows:2}" :text="form.subject"></PinyinInput>
      </div>
    </el-form-item>
    <PinyinPreview v-if="config.subjectPinyin" :text="form.subject" :pinyin="form.subjectPinyin" popover offsets></PinyinPreview>
    <el-form-item v-if="config.question" label="提问">
      <div class="exr-flex-row">
        <el-input v-model="form.question"></el-input>
        <PinyinInput v-model="form.questionPinyin" v-if="config.questionPinyin" :text="form.questionPinyin"></PinyinInput>
      </div>
    </el-form-item>
    <PinyinPreview v-if="config.questionPinyin" :text="form.question" :pinyin="form.questionPinyin" popover offsets></PinyinPreview>
    <el-form-item label="图片" v-if="config.image">
      <ImageInput v-model="form.image" :desc.sync="form.imageDesc"></ImageInput>
    </el-form-item>
    <el-form-item label="音频" v-if="config.audio">
      <FileInput v-model="form.audio" accept="audio/*"></FileInput>
    </el-form-item>
    <el-form-item label="音频原文" v-if="config.audioText">
      <PinyinGridInput :text.sync="form.audioText" :pinyin.sync="form.audioPinyin"></PinyinGridInput>
    </el-form-item>
    <el-form-item label="正确答案">
      <el-radio-group v-model="form.answer">
        <el-radio :label="1">对</el-radio>
        <el-radio :label="0">错</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item label="答案音频" v-if="config.answerAudio">
      <FileInput v-model="form.answerAudio" accept="audio/*"></FileInput>
    </el-form-item>
    <ShowAnswer v-model="form" :config="config"></ShowAnswer>
  </div>
</template>

<script>
import ShowAnswer from "./ShowAnswer"
import dialog from '@/components/mixins/dialog.js'

export default {
  name: 'DctForm',
  components: {
    PinyinPreview: require('@/components/PinyinPreview').default,
    PinyinInput: require('@/components/PinyinInput').default,
    FileInput: require('@/components/FileInput').default,
    ImageInput: require('@/components/ImageInput').default,
    PinyinGridInput: require('@/components/PinyinGridInput').default,
    ShowAnswer
  },
  props: {
    config: {},
    model: {}
  },
  mixins: [dialog],
  data () {
    return {
      form: Object.assign({}, this.model),
      answerSubjectAudio: false
    }
  },
  watch: {
    model (val) {
      this.form = Object.assign({}, val)
    }
  }
}
</script>

<style lang="scss" scoped>
  .exr-form-subject{
    display: flex;
    flex-wrap: wrap;
    margin-left: -8px;
    > div{
      flex: 1;
      margin-left: 8px;
      min-width: 300px;
    }
  }
  .exr-flex-row{
    display: flex;
    flex-wrap: wrap;
    margin-left: -8px;
    > div{
      flex: 1;
      margin-left: 8px;
    }
  }
</style>
